import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=79d09a38"
import script from "./sections.vue?vue&type=script&lang=js"
export * from "./sections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports